import React from 'react';
import fr from 'facet-rest';
import TabGroup from 'Components/ComponentLibrary/Molecules/TabGroup/TabGroup';
import { ServiceDetails } from 'Views/Page/Content/Templates/MemberDashboard/content/ServiceDetails';
import { Financials } from 'Views/Page/Content/Templates/MemberDashboard/content/Financials';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { relationshipType } from 'facet-rest/src/consts/relationships';
import {
  ActivityContainer,
} from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityContainer';

const MemberDashboardTabs = () => {
  const { pageContentResource: memberDashboardResource } = usePageContentContext();

  // Get all the tab relationships, render if there are more than 1
  const tabRelationships = memberDashboardResource.relationships().list().filter((rel) => rel.meta('type') === relationshipType.tabLink);
  if (tabRelationships.length === 0) {
    return null;
  }

  const LAYOUTS = {
    [fr.relationships.activity.name]: (<ActivityContainer relationship={memberDashboardResource.relationship(fr.relationships.activity.name)} />),
    [fr.relationships.serviceDetails.name]: (<ServiceDetails />),
    [fr.relationships.financials.name]: (<Financials />),
  };

  // If we ever want to set the tab from the server
  const url = new URL(memberDashboardResource.link('self').url());
  const search = new URLSearchParams(url.search);
  const currentTab = search.get('tab');

  return (
    <TabGroup
      resource={memberDashboardResource}
      layouts={LAYOUTS}
      selectedTab={currentTab}
      direction={'vertical'}
      tabAlignment={'flex-start'}
    />
  );
};

MemberDashboardTabs.defaultProps = {};

MemberDashboardTabs.propTypes = {};

export { MemberDashboardTabs };
